import * as React from 'react';
import { RouteProps } from 'react-router';

import { Image, Link } from '@opendoor/bricks/core';
import Layout, { FooterType, HeaderType } from '@opendoor/bricks/deprecated/UNSAFE_layout/Layout';

import imgixUrl from 'src/helpers/imgixUrl';
import { isOpendoorAppEvoWebView } from 'src/helpers/webview';

import { OpendoorLogoSVG } from './OpendoorLogoSVG';

type LogoType = 'DEFAULT' | 'BLACK';
interface ILayoutParams {
  footerType?: FooterType;
  headerType?: HeaderType;
  hideHeaderMobile?: boolean;
  logoType?: LogoType;
  renderExtra?: () => JSX.Element;
}

type DefaultFlowLayoutProps = {
  footerType?: FooterType;
  headerType?: HeaderType;
  hideHeaderMobile?: boolean;
  logoType?: LogoType;
  renderExtra?: () => JSX.Element;
};

const DefaultFlowLayout: React.FC<React.PropsWithChildren<DefaultFlowLayoutProps>> = ({
  children,
  footerType,
  headerType,
  hideHeaderMobile,
  logoType = 'DEFAULT',
  renderExtra,
}) => {
  return (
    <Layout
      analyticsName="reception-fe"
      footerType={isOpendoorAppEvoWebView ? 'NONE' : footerType}
      headerType={isOpendoorAppEvoWebView ? 'NONE' : headerType}
      hideHeaderMobile={hideHeaderMobile}
      renderExtra={renderExtra}
      renderLogo={() => (
        <Link href="/" analyticsName="reception-fe-header-logo" aria-label={null}>
          {logoType === 'DEFAULT' ? (
            <Image
              src={imgixUrl('logo-opendoor.svg')}
              alt="Opendoor"
              height={22}
              className="opendoor-logo"
            />
          ) : (
            <OpendoorLogoSVG></OpendoorLogoSVG>
          )}
        </Link>
      )}
    >
      {children}
    </Layout>
  );
};

/**
 * @deprecated
 */
export default function layoutWrapper<T>(
  ComposedComponent: React.ComponentType<T>,
  params?: ILayoutParams,
) {
  return function wrap(props: T & RouteProps) {
    return (
      <DefaultFlowLayout {...(params || ({} as ILayoutParams))}>
        <ComposedComponent {...props} />
      </DefaultFlowLayout>
    );
  };
}
